export const checkUrlToDisplayChatOption = (url) => {
  const paths = url.split("/");
  const omniOrMemberPath = paths[1] == "OmniAssist" || paths[1] == "member";
  const isPartner = paths[2] === "AMC" || paths[2] === "JJ" || paths[2] === "oneapp";
  const isPathname =
    paths[3] == "memberlookup" || paths[3] == "lookup" || paths[3] == "home";

  return omniOrMemberPath && isPartner && isPathname;
};
